<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="closeDialog"
    custom-class="change-pass">
    <el-form size="medium" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm" style="padding: 30px 10px;">
      <el-form-item label="手机号" >
        <el-input v-model="account" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="短信验证码">
        <div style="display: flex; flex-direction: row">
          <el-input style="margin-right: 12px;" v-model.trim="verCode" placeholder="请输入短信验证码"></el-input>
          <el-button type="primary" @click="getVerCode" :loading="coolDown" :disabled="disabledSendCode">{{sendCodeText}}</el-button>
        </div>
      </el-form-item>
      <el-form-item label="旧密码" prop="oldPass">
        <el-input type="password" v-model="oldPass" placeholder="请输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPass">
        <el-input type="password" v-model="newPass" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="reNewPass">
        <el-input type="password" v-model="reNewPass" placeholder="请确认新密码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button size="medium" @click="closeDialog">取 消</el-button>
    <el-button size="medium" type="primary" @click="confirmChange" :disabled="disableSubmit">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {sendVerCode, checkNewPass} from '../../utils/utils.js'
import md5 from 'js-md5'
import ct from '../../utils/constant.js'
export default {
  props: ['dialogVisible'],
  data () {
    return {
      sendCodeText: '发送',
      disabledSend: false,
      coolDown: false,
      sendVeriCodeSuccess: false,
      account: '',
      verCode: '',
      oldPass: '',
      reNewPass: '',
      newPass: '',
      disableSubmit: true
    }
  },
  watch: {
    'verCode': function (val) {
      let reg = new RegExp(/^\d{6}$/)
      if (this.sendVeriCodeSuccess || reg.test(val)) {
        this.disableSubmit = false
      } else {
        this.disableSubmit = true
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },
    getVerCode () {
      sendVerCode(this, ct.SendVeriCodeType.changePass)
    },
    confirmChange () {
      if (checkNewPass(this)) {
        this.postRequest('gcwwwifc/submitPasswordChange', {
          'LoginId': this.account.replace(/\s+/g, ''),
          'ExPassword': md5(this.oldPass).toUpperCase(),
          'NewPassword': md5(this.newPass).toUpperCase(),
          'VerifyCode': this.verCode
        }).then((res) => {
          if (res) {
            this.$message({message: res.data.message, type: 'success'})
            this.closeDialog()
            this.account = ''
            this.verCode = ''
            this.oldPass = ''
            this.reNewPass = ''
            this.newPass = ''
          }
        })
      } else {
        // return
      }
    }
  },
  computed: {
    disabledSendCode () {
      if (this.account === '') {
        return true
      } else {
        return this.disabledSend
      }
    }
  }
}
</script>
<style>
  .change-pass .el-dialog__body {
    padding:30px 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/ChangePassword.vue